export default "__VITE_PUBLIC_ASSET__f506e6a0__"